import StoreList from './StoreList/StoreList';
import StoreCheckbox from './StoreCheckbox/StoreCheckbox';

import './Store.scss';

type StoreProps = {
    rtl: boolean;
    storeList: any
    checked: boolean;
    handleCheckedChange: any;
    handleListClick: any;
}

function Store({ rtl, storeList, checked, handleCheckedChange, handleListClick }: StoreProps) {
    return (
        <div className='Store__Container'>
            <section className='store_list'>
                <StoreCheckbox
                    rtl={rtl}
                    checked={checked}
                    handleCheckedChange={handleCheckedChange}
                />

                {storeList.length > 0 && storeList.map((store: any) => {
                    return (
                        <StoreList
                            rtl={rtl}
                            store={store}
                            storeId={store.priority}
                            key={store.address.en + store.priority}
                            storeName={rtl ? `${store.address.ar}` : `${store.address.en}, ${store.cityName}`}
                            status={rtl ? store.storeStatus.label.ar : store.storeStatus.label.en}
                            timings={rtl ? store.openingHours.ar : store.openingHours.en}
                            handleListClick={handleListClick}
                            storeDistance={`${store.distance.value} ${rtl ? store.distance.unit.ar : store.distance.unit.en}`}
                        />
                    )
                })}
            </section>
        </div>
    )
}

export default Store